import React from 'react';
import HoverableVideo from '@contentlab/components/hoverable-video';

function ContentLabMedia() {
  return (
    <div style={{width: '100%', height: '100%'}}>
      <HoverableVideo
        videoUrl="https://storage.googleapis.com/brands-public-assets/content-lab/scaler-auth-asset-video.mp4"
        thumbnailUrl="https://storage.googleapis.com/brands-public-assets/content-lab/scaler-auth-asset.jpg"
        width="100%"
        height="100%"
        isHovered
        preloadVideo
        muted
        loop
        sx={{width: '100%', height: '100%'}}
      />
    </div>
  );
}

export default ContentLabMedia;
